import React from 'react';
import { IconButton } from '@material-ui/core';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';

import UserChip from 'components/UserChip';

import { CommunityFull } from '../types';

export const Lead = ({ lead, full }: { lead: CommunityFull['leads'][number]; full?: boolean }) => (
  <div style={{ display: 'flex', alignItems: 'center', margin: full ? '2px 0' : '2px 16px 2px 0' }}>
    <div style={{ flexGrow: 1, marginLeft: full ? 0 : 32 }}>
      <UserChip small user={lead.User} />
    </div>
    <div>
      <IconButton
        title={lead.User.email}
        onClick={() => {
          window.open(`mailto:${lead.User.email}`, '_blank');
        }}
        disabled={!lead.User.email}
      >
        <MailOutlineIcon color={lead.User.email ? 'primary' : 'disabled'} />
      </IconButton>

      <IconButton
        title="Phone"
        disabled={!lead.User.phone}
        onClick={() => {
          window.open(`tel:${lead.User.phone}`, '_blank');
        }}
      >
        <LocalPhoneOutlinedIcon color={lead.User.phone ? 'primary' : 'disabled'} />
      </IconButton>
    </div>
  </div>
);
